import React, { useState, useEffect } from 'react';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider, Routes } from 'react-router-dom';
import routes from '../../Utils/routes';
import { getAxiosInstance, getConfig } from '../../Utils/apiService';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import KenLoader from '../../GlobalComponents/KenLoader';
import axios from 'axios';
import { KEY_AZURE_TOKEN } from '../../Helpers/constant';
import { ConfigOptions } from '../../interfaces/Common';
import AuthLayout from '../../Components/AuthLayout';
import AppLayout from '../../Components/AppLayout';
import { PrivateRoute, PublicRoute } from '../../Utils/helperFunctions';
import storage from '../../storageService';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { useContext } from 'react';
import MyProfile from '../MyProfile';
import CareerDetailsContent from '../MyProfile/components/CareerDetailsContent';
import YourGroups from '../Groups/Your Groups';
import ResumeCard from '../Jobs/ResumeCard';
import CreateResume from '../Jobs/CreateResume';
import FormField from '../Mentorship/formField';
import MentorDetails from '../Mentorship/mentorDetails';
import Schedule from '../Schedule';
import FAQ from '../Service/components/FAQ';
import AppliedJobs from '../Jobs/AppliedJobs';
import SavedJobs from '../Jobs/SavedJobs';
import MyJobs from '../Jobs/MyJobs';
import YourGroupsDetails from '../Groups/YourGroupsDetails';
import Chats from '../Chats';
import PrivacyPolicy from '../Auth/PrivacyPolicy';
import MentorshipDetails from '../Mentorship/MentorshipDetails';
import BusinessDirectory from '../BusinessDirectory/BusinessDirectory';
import CreateBusinessDirectory from '../BusinessDirectory/BusinessDirectory/CreateBusinessDirectory';
import Photos from '../BusinessDirectory/Photos';
import PhotoAlbumUpload from '../BusinessDirectory/Photos/Components/photoAlbumUpload';
import Resources from '../BusinessDirectory/Resources';
import MyFeed from '../MyFeed';
import CreatedGroupsDetails from '../Groups/CreatedGroupsDetails';
import AlbumViewer from '../BusinessDirectory/Photos/Components/albumViewer';
import BusinessDetailPage from '../BusinessDirectory/BusinessDirectory/BusinessDetail';
import MentorshipMobileview from '../Mentorship/Mentorship/MentorshipMobileview';
import NetworkMobileView from '../Network/NetworkMobileView';
import JobsViewAll from '../Jobs/JobsViewAll';
import ActiveCampaigns from '../FundraiserII/ActiveCampaigns';
import ChatDetailPage from '../Chats/ChatDetailPage';
import AllBusinesses from '../BusinessDirectory/BusinessDirectory/AllBusinesses';
import MyBusinesses from '../BusinessDirectory/BusinessDirectory/MyBusinesses';
import CookiePolicy from '../Auth/CookiePolicy';
import AllAlumniSurvey from '../Survey/components/AlumniSurvey/AllAlumniSurvey';
import InAppNotificationsMobile from '../../Components/AppLayout/InAppNotificationMobile';
import MentorshipPreferences from '../Settings/components/MentorShip/index';
import EmailSignup from '../Auth/SignUp/Email';

// const Fundraise = React.lazy(() => import('../Fundraise'));
// const FundraiseDetails = React.lazy(() => import('../Fundraise/fundraiseDetails'));
const OnBoarding = React.lazy(() => import('../OnBoarding/index'));
const Signup = React.lazy(() => import('../Auth/SignUp/index'));
const VerifyOTP = React.lazy(() => import('../Auth/VerifyOtp/index'));
const EmailConformation = React.lazy(() => import('../Auth/ConfirmEmail/index'));
const Login = React.lazy(() => import('../Auth/Login/index'));
const ForgotPassword = React.lazy(() => import('../Auth/ForgotPassword/index'));
const ConfirmPassword = React.lazy(() => import('../Auth/ConfirmPassword/index'));
const Home = React.lazy(() => import('../Home/index'));
const Events = React.lazy(() => import('../Events/index'));
const Jobs = React.lazy(() => import('../Jobs/index'));
const JobDetails = React.lazy(() => import('../Jobs/JobDetails/index'));
const PostJob = React.lazy(() => import('../Jobs/PostJob/index'));
const Mentorship = React.lazy(() => import('../Mentorship/index'));
const Groups = React.lazy(() => import('../Groups/index'));
const DiscoverGroups = React.lazy(() => import('../Groups/DiscoverGroups'));
const CreateGroup = React.lazy(() => import('../Groups/CreateGroup'));
const DiscoverGroupsDetails = React.lazy(() => import('../Groups/DiscoverGroupsDetails'));
const Survey = React.lazy(() => import('../Survey/index'));
const CreateSurvey = React.lazy(() => import('../Survey/CreateSurvey'));
const YourSurvey = React.lazy(() => import('../Survey/YourSurvey/index'));
const Service = React.lazy(() => import('../Service/index'));
const TicketPreview = React.lazy(() => import('../Service/components/Ticket/TicketPreview'));
const Answers = React.lazy(() => import('../Service/components/Questions/Answers'));
const RequestService = React.lazy(() => import('../Service/components/Requests/RequestService'));
const Test = React.lazy(() => import('../Test'));
const Network = React.lazy(() => import('../Network/index'));
const NetworkDetails = React.lazy(() => import('../Network/NetworkDetails/index'));
const Settings = React.lazy(() => import('../Settings/index'));
const SocialLinks = React.lazy(() => import('../../Containers/SocialLinks/index'));
const FundraiseFlame = React.lazy(() => import('../FundraiserII'));
const FundraiseFlameDetails = React.lazy(() => import('../FundraiserII/Details'));
const MyFundsFlameDetails = React.lazy(() => import('../FundraiserII/MyRequests'));
const FlameSignup = React.lazy(() => import('../Auth/FlameSignup'));
const LandingPage = React.lazy(() => import('../LandingPage'));

const MainLayout: React.FunctionComponent = () => {
  const [isFormUnchanged, setIsFormUnchanged] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const { state: { isLoading } } = useContext(AuthContext);
  
  useEffect(() => {
    const initializeApp = async () => {
      try {
        await getAxiosInstance();
        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to initialize app:', error);
        setIsInitialized(true);
      }
    };
    
    initializeApp();
  }, []);

  // Show loading while app is initializing or auth is loading
  if (!isInitialized || isLoading) {
    return <KenLoader />;
  }

  const router = createBrowserRouter(
    createRoutesFromElements(
      <React.Fragment>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.landingpage} />} />
        <Route path="/test" element={<Test />} />

        {/* Public Routes */}
        <Route
          path={routes.landingpage}
          index
          element={
            <PublicRoute>
            {/* <Login /> */}
        <LandingPage/>
            </PublicRoute>
          }
        />
             <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
            <Login />
        {/* <LandingPage/> */}
            </PublicRoute>
          }
        />

        <Route
          path={routes.privacyPolicy}
          index
          element={
            <PrivacyPolicy />
          }
        />
        <Route
          path={routes.cookiePolicy}
          index
          element={
            <CookiePolicy />
          }
        />

        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signupRequest}
          element={
            <PrivateRoute>
              <FlameSignup />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
           <Route
          path={routes.emailsignup}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailSignup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />

        {/* Private Routes */}
        <Route
          path={routes.onboarding}
          element={
            <PrivateRoute>
              <OnBoarding />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* My Profile */}
        <Route
          path={routes.myProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyProfile />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* <Route
          path={routes.InAppNotificationsMobile}
          element={
            <PrivateRoute>
              <AppLayout>
                <InAppNotificationsMobile />
              </AppLayout>
            </PrivateRoute>
          }
        /> */}
        <Route
          path={routes.careerDetails}
          element={
            <PrivateRoute>
              <AppLayout>
                <CareerDetailsContent initialTab="Applied" onBack={() => window.location.href = routes.myProfile} />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Events */}
        <Route
          path={`events/*`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Events />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Jobs */}

        <Route
          path={`${routes.jobs}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Jobs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.appliedJobs}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <AppliedJobs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.savedJobs}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <SavedJobs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.myJobs}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyJobs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.myFeed}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyFeed />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.jobDetails}/:jobId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <JobDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.postJob}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <PostJob />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.resumeLibrary}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ResumeCard />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.resumeBuilder}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CreateResume />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* settings */}
        <Route
          path={`${routes.settings}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* schedule */}
        <Route
          path={`${routes.schedule}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Schedule />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.chats}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Chats />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.chatsdetails}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ChatDetailPage />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* MentorShip */}

        <Route
          path={`${routes.mentorship}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Mentorship />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.jobsViewAll}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <JobsViewAll />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.viewallMentorship}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MentorshipMobileview />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.viewallNetwork}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <NetworkMobileView />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.mentorship}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Mentorship />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.setupPreference}`}
          
          element={
            <PrivateRoute>
              <AppLayout>
                <MentorshipPreferences setIsFormUnchanged={setIsFormUnchanged} />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.mentorDetails}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MentorDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.fundraise}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FundraiseFlame />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.fundraiseDetails}/:fundraiseId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FundraiseFlameDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.myFunds}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyFundsFlameDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.activeCampaigns}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ActiveCampaigns />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Groups */}

        <Route
          path={`${routes.groups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Groups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.discoverGroups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <DiscoverGroups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.yourGroups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <YourGroups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.discoverGroups}/:groupId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <DiscoverGroupsDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.yourGroupsDetails}/:groupId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <YourGroupsDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.CreatedGroupsDetails}/:groupId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CreatedGroupsDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.createGroup}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CreateGroup />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Network */}
        <Route
          path={`${routes.network}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Network />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.network}/:networkId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <NetworkDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.businessdirectory}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <BusinessDirectory />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.photos}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Photos />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.PhotoAlbumUpload}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <PhotoAlbumUpload contactId={''} />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.AlbumViewer}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <AlbumViewer />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.BusinessDetail}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <BusinessDirectory />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.resources}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Resources />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.allBusinesses}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <AllBusinesses />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.myBusinesses}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyBusinesses />
              </AppLayout>
            </PrivateRoute>
          }
        /><Route
          path={`${routes.createbusinessdirectory}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CreateBusinessDirectory />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.resources}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Resources />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.mentorshipDetailview}/:mentorshipId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MentorshipDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Survey */}
        <Route
          path={`${routes.survey}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Survey />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.createSurvey}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CreateSurvey />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.AllAlumniSurvey}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <AllAlumniSurvey />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.yoursurvey}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <YourSurvey />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Service and Support */}

        <Route
          path={`${routes.service}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Service />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.serviceFAQ}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FAQ />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.RequestService}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RequestService />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}/:serviceId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.socialLinks}`}
          element={
            <PrivateRoute>
              <SocialLinks />
            </PrivateRoute>
          }
        />
      </React.Fragment>
    )
  );

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default MainLayout;
